import { render, staticRenderFns } from "./New.vue?vue&type=template&id=c54d9124&scoped=true"
import script from "./New.vue?vue&type=script&lang=js"
export * from "./New.vue?vue&type=script&lang=js"
import style0 from "./New.vue?vue&type=style&index=0&id=c54d9124&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54d9124",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c54d9124')) {
      api.createRecord('c54d9124', component.options)
    } else {
      api.reload('c54d9124', component.options)
    }
    module.hot.accept("./New.vue?vue&type=template&id=c54d9124&scoped=true", function () {
      api.rerender('c54d9124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/SurveyManage/New.vue"
export default component.exports